import React from "react";
import "uq-global-ec-uikit/components/dist/css/main.global.css";
import "uq-global-ec-uikit/components/dist/css/main.fonts.css";
import "uq-global-ec-uikit/components/dist/css/main.css";
import * as globalJS from "uq-global-ec-uikit/components/dist/js/main.global.js";
import ja_JP from "fr-global-stylingbook-wording/wording/UQ-ja-JP";
import en_US from "fr-global-stylingbook-wording/wording/UQ-en-US";
import en_UK from "fr-global-stylingbook-wording/wording/UQ-en-UK";
import en_FR from "fr-global-stylingbook-wording/wording/UQ-en-FR";
import fr_FR from "fr-global-stylingbook-wording/wording/UQ-fr-FR";
import en_DE from "fr-global-stylingbook-wording/wording/UQ-en-DE";
import de_DE from "fr-global-stylingbook-wording/wording/UQ-de-DE";
import en_ES from "fr-global-stylingbook-wording/wording/UQ-en-ES";
import es_ES from "fr-global-stylingbook-wording/wording/UQ-es-ES";
import en_IT from "fr-global-stylingbook-wording/wording/UQ-en-IT";
import it_IT from "fr-global-stylingbook-wording/wording/UQ-it-IT";
import en_DK from "fr-global-stylingbook-wording/wording/UQ-en-DK";
import en_SE from "fr-global-stylingbook-wording/wording/UQ-en-SE";
import en_NL from "fr-global-stylingbook-wording/wording/UQ-en-NL";
import nl_NL from "fr-global-stylingbook-wording/wording/UQ-nl-NL";
import en_BE from "fr-global-stylingbook-wording/wording/UQ-en-BE";
import nl_BE from "fr-global-stylingbook-wording/wording/UQ-nl-BE";
import fr_BE from "fr-global-stylingbook-wording/wording/UQ-fr-BE";
import en_EU from "fr-global-stylingbook-wording/wording/UQ-en-EU";
import ko_KR from "fr-global-stylingbook-wording/wording/UQ-ko-KR";
import en_CA from "fr-global-stylingbook-wording/wording/UQ-en-CA";
import fr_CA from "fr-global-stylingbook-wording/wording/UQ-fr-CA";
import en_AU from "fr-global-stylingbook-wording/wording/UQ-en-AU";
import en_ID from "fr-global-stylingbook-wording/wording/UQ-en-ID";
import id_ID from "fr-global-stylingbook-wording/wording/UQ-id-ID";
import en_IN from "fr-global-stylingbook-wording/wording/UQ-en-IN";
import en_MY from "fr-global-stylingbook-wording/wording/UQ-en-MY";
import en_PH from "fr-global-stylingbook-wording/wording/UQ-en-PH";
import en_SG from "fr-global-stylingbook-wording/wording/UQ-en-SG";
import en_TH from "fr-global-stylingbook-wording/wording/UQ-en-TH";
import th_TH from "fr-global-stylingbook-wording/wording/UQ-th-TH";
import en_VN from "fr-global-stylingbook-wording/wording/UQ-en-VN";
import vi_VN from "fr-global-stylingbook-wording/wording/UQ-vi-VN";

import i18nInit from "../../../util/i18n";

globalJS.keyboardOnlyFocus();

const resources = {
  "ja-JP": { translation: ja_JP },
  "en-US": { translation: en_US },
  "en-UK": { translation: en_UK },
  "en-FR": { translation: en_FR },
  "fr-FR": { translation: fr_FR },
  "en-DE": { translation: en_DE },
  "de-DE": { translation: de_DE },
  "en-ES": { translation: en_ES },
  "es-ES": { translation: es_ES },
  "en-IT": { translation: en_IT },
  "it-IT": { translation: it_IT },
  "en-DK": { translation: en_DK },
  "en-SE": { translation: en_SE },
  "en-NL": { translation: en_NL },
  "nl-NL": { translation: nl_NL },
  "en-BE": { translation: en_BE },
  "nl-BE": { translation: nl_BE },
  "fr-BE": { translation: fr_BE },
  "en-EU": { translation: en_EU },
  "ko-KR": { translation: ko_KR },
  "en-CA": { translation: en_CA },
  "fr-CA": { translation: fr_CA },
  "en-AU": { translation: en_AU },
  "en-ID": { translation: en_ID },
  "id-ID": { translation: id_ID },
  "en-IN": { translation: en_IN },
  "en-MY": { translation: en_MY },
  "en-PH": { translation: en_PH },
  "en-SG": { translation: en_SG },
  "en-TH": { translation: en_TH },
  "th-TH": { translation: th_TH },
  "en-VN": { translation: en_VN },
  "vi-VN": { translation: vi_VN }
};
i18nInit(resources);

const UQLayout = (props: any): any => <div>{props.children}</div>;

export default UQLayout;
